import React, { lazy, Suspense } from 'react';

const TransactionUploader = lazy(() => import('../../legacy/components/TransactionUploader'));

const ReactLazyTransactionUploader: React.FC<{ 
    buildingId: string; 
    organizationId: string; 
}> = ({ buildingId, organizationId }) => {
  return (
        <Suspense fallback={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div className="flex items-center gap-2 text-muted-foreground">
            <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            <span>Loading uploader…</span>
          </div>
        </div>}>
            <TransactionUploader
                setAnalysisResult={(res) => console.log(res)}
                buildingId={buildingId}
                organizationId={organizationId}
            />
        </Suspense>
    );
};

export default ReactLazyTransactionUploader;
